module.exports = __webpack_public_path__ + "static/media/laravel.78afd3e3.png";